const parseLocationSearch = (value) => {
  const searchParams = new URLSearchParams(String(value || ''));
  const parsed = {};

  for (const [key, searchValue] of searchParams.entries()) {
    const normalizedKey = String(key || '').trim();

    if (!normalizedKey) {
      continue;
    }

    parsed[normalizedKey] = searchValue;
  }

  return parsed;
};

export default parseLocationSearch;
